var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-main',[_c('v-container',{staticClass:"justify-center align-center fill-height"},[_c('v-text-field',{attrs:{"outlined":""}},[_vm._v(" this is auth ")])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }